import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import TrophyFAPage from '../../components/TrophyFAPage';
import logo from '../../assets/logo.svg';
import dummymarksheet from '../../assets/applause/dummymarksheet.png';
import tatanexoncar from '../../assets/applause/tatanexoncar.png';
import iphone15pro from '../../assets/applause/iphone15pro.png';
import tanishq10gm from '../../assets/applause/tanishq10gm.png';
import delinspiron from '../../assets/applause/delinspiron.png';
import voucher2000 from '../../assets/applause/voucher2000.png';
import './sparkle.css';

const MyApplauseMarksheetsContest = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    document.title = isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);

  // Update currentDateTime every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
      <div className='bg-black [&-p]:text-white [&_h2]:text-yellow-200'>
        <div className="max-w-full mx-auto p-6 bg-black text-white rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-center text-yellow-200 mb-4">Turn Your Mark Sheets into Mega Prizes!</h1>
          <p className="text-lg lg:text-xl text-center text-gray-200 mb-8">Mark Sheets are more than just paper on Think5Whys — they could score you & your family incredible rewards!</p>
          
          <div className="flex justify-center mb-6">
            <img className="align-middle" style={{width: "250px", height:"auto"}} src={dummymarksheet} alt="Marks Sheet" />
          </div>

          <h2 className="text-lg lg:text-xl font-bold text-yellow-200 mb-4">Prizes Categories</h2>
          
          <div className="bg-black p-4 rounded-lg mb-2 border border-blue-400">
            <h3 className="text-m lg:text-xl font-semibold text-yellow-200 mb-2">Self</h3>
            <ul className="list-disc list-inside [&_li]:text-white">
              <li>1st Prize: Samsung Smart Phone (1)</li>
              <li>2nd Prize: Avon Bicycle (2)</li>
              <li>3rd Prize: boAt Airdopes / Cricket bat (3)</li>
              <li>boAt Smartwatch (5 nos.)</li>
              <li>Zebronics Headphones (10 nos.)</li>
            </ul>
          </div>
          
          <div className='border border-blue-400 p-4'>
            <div className="bg-black p-1 rounded-lg">
              <h3 className="text-m lg:text-lg font-semibold text-yellow-200 mb-2">Father/Grand-Father</h3>
              <p className='text-white'>Smart Phone (5 nos.)</p>
            </div>
            
            <div className="bg-black p-1 rounded-lg">
              <h3 className="text-m lg:text-lg font-semibold text-yellow-200 mb-2">Mother/Grand-Mother</h3>
              <p className='text-white'>Fashion & Accessories Gift Voucher worth Rs. 10,000.00 (5 nos.)</p>
            </div>
            
            <div className="bg-black p-1 rounded-lg">
              <h3 className="text-m lg:text-lg font-semibold text-yellow-200mb-2">BFF</h3>
              <p className='text-white'>Gift Voucher worth Rs. 1000.00 (50 nos.)</p>
            </div>
          </div>

          <div className='flex flex-col items-center justify-center text-center'>
            <p className="text-m lg:text-lg text-yellow-400 mb-2">...and 3,00,000 additional early bird prizes!</p>
            
            <p className="text-m lg:text-xl font-bold text-yellow-400 mb-2">Celebrate 1,00,000 Think5Whys DeepThinking Program Certificate Winners:</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 bg-black p-0 rounded-lg mb-2">
  
            <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg">
              <h3 className="text-m lg:text-lg font-bold text-white mb-2">Family</h3>
              <img className="align-middle w-24 h-24 mb-4" style={{width: "250px", height:"250px"}} src={tatanexoncar} alt="Tata Nexon Car" />
              <p className="text-lg font-semibold text-orange-400">1 winner</p>
            </div>

            <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg">
              <h3 className="text-m lg:text-lg font-bold text-white mb-2">Student</h3>
              <img className="align-middle w-24 h-24 mb-4" style={{width: "250px", height:"250px"}} src={delinspiron} alt="Tata Nexon Car" />
              <p className="text-lg font-semibold text-orange-400">5 winners</p>
            </div>

            <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg">
              <h3 className="text-m lg:text-lg font-bold text-white mb-2">Mother</h3>
              <img className="align-middle w-24 h-24 mb-4" style={{width: "250px", height:"250px"}} src={tanishq10gm} alt="Tata Nexon Car" />
              <p className="text-lg font-semibold text-orange-400">5 winners</p>
            </div>

            <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg">
              <h3 className="text-m lg:text-lg font-bold text-white mb-2">Father</h3>
              <img className="align-middle w-24 h-24 mb-4" style={{width: "250px", height:"250px"}} src={iphone15pro} alt="Tata Nexon Car" />
              <p className="text-lg font-semibold text-orange-400">5 winners</p>
            </div>

            <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg">
              <h3 className="text-m lg:text-lg font-bold text-white mb-2">Friends</h3>
              <img className="align-middle w-24 h-24 mb-4" style={{width: "250px", height:"250px"}} src={voucher2000} alt="Tata Nexon Car" />
              <p className="text-lg font-semibold text-orange-400">500 winners</p>
            </div>
          </div>
          
          <div className="flex flex-col items-center text-center p-6 bg-black border border-blue-400 text-white shadow-lg rounded-lg mx-auto">
            <h1 className="text-lg lg:text-xl font-bold text-yellow-200 mb-4">Teacher's Exclusive: By the Teachers to the Teachers</h1>
            <p className="text-white text-sm lg:text-m mb-4">
              Applause for not only top performers but improvers also. 
            </p>
            <h2 className="text-m lg:text-lg font-bold text-yellow-200 mb-4">100 teachers will win personalized pen set or stationary as lucky winner.</h2>

            <p className="text-white text-sm lg:text-m mb-4">
              Referrer / recommend to purchase following innovative Books / Programs, become companion with students in their learing journey with our tool.
            </p>
            <h2 className="text-sm lg:text-m font-bold text-white mb-4">Celebrate 1,00,000 Think5Whys DeepThinker Certificate</h2>
            <h2 className="text-sm lg:text-m font-bold text-white mb-4">Celebrate 1,00,000 Think5Whys Periodic Table Champion Certificate</h2>
            <h2 className="text-sm lg:text-m font-bold text-white mb-4">Celebrate 1,00,000 Active CAFE (Current Affair Edge) Students</h2>
            <h2 className="text-sm lg:text-m font-bold text-white mb-4">Celebrate Achievement of 1,00,000 Early Learning Children Collection</h2>

            <p className="text-lg text-yellow-200 font-semibold mb-4">Prizes</p>
            <p className="text-white text-sm lg:text-m mb-4">
              35 teachers (lucky winners) will get prizes up to ₹1,00,000 in each of the above 4 categories to pick from:
            </p>
            <p className="text-white mb-4">
              <span className="font-semibold text-yellow-200">Option to choose any 1 from the following:</span>
            </p>
            <ol className="text-sm lg:text-m text-center space-y-2 text-white [&_li]:text-white">
              <li><strong>Tech Gadgets:</strong> Tablets or smart devices for classNameroom use.</li>
              <li><strong>Professional Development Grants:</strong> Funding for attending workshops or conferences.</li>
              <li><strong>classNameroom Makeover Package:</strong> Funds to enhance their classNameroom environment.</li>
              <li><strong>Travel Vouchers:</strong> For educational trips or conferences.</li>
              <li><strong>Memberships:</strong> Annual subscriptions to educational organizations or resources.</li>
              <li><strong>EV 2 Wheelers Purchase Grant</strong></li>
            </ol>
            <p className="text-yellow-200 mb-4 mt-4">
              <span className="text-sm lg:text-m font-semibold ">Complementary incentive: Every teacher will get incentive upto 30% of the product price (under Multilevel Referral Program) they refer and students/parent buys.</span>
            </p>
          </div>
          
          <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg mt-4">
            <h2 className="text-lg lg:text-xl font-bold text-yellow-200 mb-4 mt-4">How to Join the Fun</h2>
            <ol className="list-decimal list-inside text-white mb-6 [&_li]:text-white">
              <li>Register at <a href="https://www.think5whys.com" className="text-indigo-500 underline">www.think5whys.com</a></li>
              <li>Applause for your, parent’s, grandparents, children, student and friends' marks</li>
              <li>Check out the "Turn Marksheets into Mega Prizes" page for details</li>
              <li>Contest Starts: November 1, 2024</li>
              <li>This contest is open for customers in India only.</li>
              <li>Terms & Conditions apply as per the Post / Add Applause Form.</li>
            </ol>
          
            <h2 className="text-xl font-semibold text-yellow-200 mb-4">Periodic Rank Updates</h2>
            <p className="text-white mb-6">Track if you ranked in the top 500 list on the leaderboard!</p>
            
            <p className="text-sm lg:text-m font-bold text-orange-500 mb-4">Important: Keep your marksheet handy to claim your prize.</p>

            <h2 className="text-lg lg:text-xl font-bold text-yello-200 mb-4">Ways to Rack Up Points</h2>
            
            <ul className="text-sm list-disc list-inside text-white mb-6 [&_li]:text-white">
              <li>100 points for signing up (All registrants will get a free one-year subscription of Digital Talking Card worth ₹300).</li>
              <li>100 points for marks {'>'} 50%</li>
              <li>100 points for each RCA record</li>
              <li>100 points for each Chronicle record</li>
              <li>100 points for each page of the Mini CAFE Digital Multimedia Book (use code THINK5WHYS to get it free).</li>
              <li>1,000 points for buying, referring, or gifting anyone from Think5Whys, Periodic Table, Children’s Collection 1, MOBook, or CAFE Digital Book.</li>
              <li>5,000 points for earning the Think5Whys or Periodic Table Champion Certification.</li>
            </ul>
            <p className="text-sm lg:text-m font-bold text-center text-yellow-200">Don’t let those marksheets collect dust—use them to win big!</p>
          </div>
        </div>
        <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/about-us" className="hover:text-teal-300">About</Link>
              <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
              <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
            </div>
          </div>
        </footer>     
      </div>
  );
}

export default MyApplauseMarksheetsContest;

